import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core";
import Snackbar from '@material-ui/core/Snackbar';
import { Alert } from "@material-ui/lab";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const styles = theme => ({
    root: {
        minWidth: "150px",
        backgroundColor: "#424242",
        color: "white",
    },
});

const StyledInfoIcon = withStyles({
    root: {
        color: 'white',
    },
})(InfoOutlinedIcon);

const CustomSnackbar = (props) => {
    const { snackbarState, classes } = props;
    const mobileText = snackbarState?.mobile?.show ? `Mobile: ${snackbarState?.mobile.counter ?? "-"}/${snackbarState?.mobile.selectedNumber ?? "-"} ` : "";
    const workplaceText = snackbarState?.workplace?.show ? `${mobileText ? "| " : ""} Work: ${snackbarState?.workplace.counter ?? "-"}/${snackbarState?.workplace.selectedNumber ?? "-"} ` : "";
    const storageText = snackbarState?.storage?.show ? `${mobileText || workplaceText ? "| " : ""}Storage: ${snackbarState?.storage.counter ?? "-"}/${snackbarState?.storage.selectedNumber ?? "-"} ` : "";

    const orderText = snackbarState?.order?.show ? `Order ${snackbarState.order.OrderInventoryID} ${snackbarState.order.Generated ?? "-"}/${snackbarState.order.ToGenerate ?? "-"} ` : "";
    const colliText = snackbarState?.colli?.show ? `${orderText ? "| " : ""}Colli ${snackbarState.colli.ColliInventoryID} ${snackbarState.colli.Generated ?? "-"}/${snackbarState.colli.ToGenerate ?? "-"} ` : "";
    const transportColliText = snackbarState?.transportColli?.show ? `${orderText || colliText ? "| " : ""}TransportColli ${snackbarState.transportColli.TransportColliInventoryID} ${snackbarState.transportColli.Generated ?? "-"}/${snackbarState.transportColli.ToGenerate ?? "-"} ` : "";
    const customText = snackbarState?.custom?.show ? `${orderText || colliText || transportColliText ? "| " : ""}Custom ${snackbarState.custom.Generated ?? "-"}/${snackbarState.custom.ToGenerate ?? "-"} ` : "";

    return (
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={snackbarState?.opened}>
            <>
                {snackbarState?.mobile?.show || snackbarState?.workplace?.show || snackbarState?.storage?.show ?
                    <Alert severity="info" className={classes.root} icon={<StyledInfoIcon color="action" />}>
                        Downloaded: {`${mobileText}${workplaceText}${storageText}`}
                    </Alert> : null}

                {snackbarState?.order?.show || snackbarState?.colli?.show || snackbarState?.transportColli?.show || snackbarState?.custom?.show ?
                    <Alert severity="info" className={classes.root} icon={<StyledInfoIcon color="action" />}>
                        Generating: {`${orderText}${colliText}${transportColliText}${customText}`}
                    </Alert> : null}
            </>
        </Snackbar>
    )
}

const mapStateToProps = (state) => {
    return {
        snackbarState: state.snackbarState
    }
}

export default connect(
    mapStateToProps,
    null
)(withStyles(styles, { withTheme: true })(CustomSnackbar));